/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_Signed_In_AsInputs */

const en_auth_login_signed_in_as = /** @type {(inputs: Auth_Login_Signed_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signed in as`)
};

const pl_auth_login_signed_in_as = /** @type {(inputs: Auth_Login_Signed_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zalogowano jako`)
};

/**
* | output |
* | --- |
* | "Signed in as" |
*
* @param {Auth_Login_Signed_In_AsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_login_signed_in_as = /** @type {((inputs?: Auth_Login_Signed_In_AsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_Signed_In_AsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_login_signed_in_as(inputs)
	return en_auth_login_signed_in_as(inputs)
});